<template>
  <div :class="['instant-player-cell', { playing: isPlaying }]">
    <slot name="spinner">
      <PlayerSpinner v-if="isSpinner" class="spinner" />
    </slot>
    <slot name="mute-button">
      <WButtonMute
        :key="`mute-${isMute ? 'on' : 'off'}`"
        :is-mute="isMute"
        @on-toggle-mute="() => toggleMute(isMute)"
      />
    </slot>
    <div class="video-area-wrap">
      <div
        ref="playerElement"
        class="video-area"
        role="button"
        @click="handleClickPlayer"
      ></div>
    </div>

    <div class="thumbnail-area-wrap">
      <slot name="cell-component"></slot>
    </div>
  </div>
</template>

<script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue'
  import { useInstantPlayer } from '@/common/use/useInstantPlayer'
  import WButtonMute from '@/components/button/WButtonMute'
  import PlayerSpinner from '@/components/loading/PlayerSpinner'

  const props = defineProps({
    contentType: {
      type: String,
      default: '',
    },
    contentId: {
      type: String,
      default: '',
    },
    targetAge: {
      type: Number,
      default: 0,
    },
    isPlayVideo: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['on-click-player'])

  const { startPlay, stopPlay, toggleMute, isMute, isSpinner, isPlaying } =
    useInstantPlayer()

  const playerElement = ref(null)

  const startPlayer = () => {
    if (!isPlaying.value) {
      startPlay({
        playerElement: playerElement.value,
        contentType: props.contentType,
        contentId: props.contentId,
        targetAge: props.targetAge,
      })
    }
  }

  const handleClickPlayer = () => {
    emit('on-click-player')
  }

  watch(
    () => props.isPlayVideo,
    (newPlayValue) => {
      newPlayValue ? startPlayer() : stopPlay()
    },
  )
</script>
<style lang="scss" scoped>
  .instant-player-cell {
    position: relative;
    cursor: pointer;
    &.playing {
      .video-area-wrap {
        z-index: 2;
        opacity: 1;
      }
      .w-button-mute {
        opacity: 1;
        transition: opacity 0.5s linear 0.7s;
      }
    }
    .video-area-wrap {
      opacity: 0;
      transition: opacity 0.5s linear 0.5s;
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 100px;
    }
    .spinner {
      position: absolute;
      bottom: 12px;
      right: 8px;
      opacity: 1;
      z-index: 11;
      transition: opacity 0.5s linear 0.5s;
    }
    .w-button-mute {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
    .tag-age {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 34px;
    }
  }
</style>
